<template>
  <v-app>
    <router-view name="header" />
    <transition name="fade">
      <router-view name="content" />
    </transition>
    <Loading v-show="isLoading" />
    <v-snackbar
      v-model="$store.state.common.snack"
      :timeout="2000"
      top
      color="#05523E"
    >
      {{ $store.state.common.snackText }}
    </v-snackbar>
    <v-snackbar
      v-model="$store.state.common.snackErr"
      :timeout="2000"
      top
      color="#ff4c4c"
    >
      {{ $store.state.common.snackErrText }}
    </v-snackbar>
  </v-app>
</template>

<script>
import Loading from "./components/Common/Loading.vue";
import { mapState } from "vuex";

export default {
  name: "App",
  components: { Loading },
  data() {
    return {
      mobileCheck: false,
    };
  },
  mounted() {
    window.addEventListener("resize", this.onResize, { passive: true });
  },
  methods: {
    onResize() {
      this.$store.state.common.isMobile = window.innerWidth <= 360;
    },
    isMobile() {
      const user = navigator.userAgent;

      if (user.indexOf("iPhone") > -1 || user.indexOf("Android") > -1) {
        this.mobileCheck = true;
      }

      return this.mobileCheck;
    },
  },
  computed: mapState("common", ["isLoading"]),
};
</script>
